import NotFound from "./pages/not-found";
import LandingPage from "./pages/landing-page";
import UpgradeZba from "./pages/upgrade-zba";
import Waiting from "pages/waiting";
import Notice from "pages/notice";

const routes = [
  { key: "empty", path: "/*", exact: true, element: <NotFound /> },
  { key: "notfound", path: "/nf", exact: true, element: <NotFound /> },
  { key: "notice", path: "/notice", exact: true, element: <Notice /> },
  { key: "lp", path: "/lp", exact: true, element: <LandingPage /> },
  {
    key: "upgradezba",
    path: "/upgrade-zba",
    exact: true,
    element: <UpgradeZba />,
  },
  {
    key: "waiting",
    path: "/waiting",
    exact: true,
    element: <Waiting/>,
  }
];
export default routes;
